import { Util } from '../utils/Commom';
export var process = function (chart, config) {
    var cCoord = Util.deepClone(config.coord);
    if (!cCoord) {
        return chart.coord('rect');
    }
    var type = cCoord.type || 'rect';
    var options = Util.omit(cCoord, ['type']);
    return chart.coord(type, options);
};
//# sourceMappingURL=setCoordConfig.js.map